import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api/api.service';
import { ITrainingCenterConfiguration } from '@precheckin/models/training-center-configuration/training-center-configuration.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrainingCentersConfigurationsService {
  private endpoint = 'trainingCenterConfigurations';

  constructor(private apiService: ApiService) { }

  getByTrainingCenterId(
    trainingCenterId: string
  ): Observable<ITrainingCenterConfiguration> {
    return this.apiService.get<ITrainingCenterConfiguration>(
      `${this.endpoint}/${trainingCenterId}?isGeminiSite=true`
    );
  }
}
